import logoImg from "@images/logo-g.png"
import logoGzImg from "@imagesgz/logo-g.png"
import buyImg from "@images/buy.png"
import buyGzImg from "@imagesgz/buy.png"
import classnames from "@utils/classnames"
import React, { useContext, useEffect, useState } from "react"
import Clickable from "../clickable"
import * as styles from "./nav.module.scss"
import config from "@config"
import CardButton from "../button"
import { ThemeContext } from "@src/context"

const menu = [
  { href: "#news", name: "最新资讯" },
  { href: "#intro", name: "活动介绍" },
  { href: "#play", name: "玩法" },
  { href: "#stage", name: "舞台" },
  { href: "#guests", name: "嘉宾" },
  { href: "#goods", name: "现场贩售" },
]

const Nav = React.memo(({ location }) => {
  const theme = useContext(ThemeContext)
  const [open, setOpen] = useState(false)
  const [visible, setVisible] = useState(false)
  const buyLink = theme === "gz" ? config.linksGz.buy : config.links.buy
  useEffect(() => {
    const scrollEvent = () => {
      const y = window.scrollY
      setVisible(y >= 400)
    }
    window.addEventListener("scroll", scrollEvent)
    return () => {
      window.removeEventListener("scroll", scrollEvent)
    }
  }, [])

  return (
    <>
      {open && (
        <div
          className={styles.bg}
          onClick={() => {
            setOpen(false)
          }}
        />
      )}
      <nav
        className={classnames(styles.nav, {
          [styles.open]: open,
          [styles.visible]: visible,
        })}
      >
        <Clickable
          appNavTo="https://www.gcores.com"
          className={styles.logoContainer}
        >
          <img src={logoImg} alt="logo" className={styles.logo} />
          <span>核聚变2021 Tour</span>
        </Clickable>
        <div className={styles.right}>
          <ul
            className={styles.menu}
            onClick={e => {
              if (e.target.nodeName.toLocaleLowerCase() === "a") {
                setOpen(false)
              }
            }}
          >
            {menu.map(({ name, href }) => {
              return (
                <li key={name}>
                  <Clickable href={href}>
                    <span className={styles.logoContainer}>
                      <img src={logoImg} alt="logo" className={styles.logo} />
                    </span>
                    <span className={styles.menuName}>{name}</span>
                  </Clickable>
                </li>
              )
            })}
            <li className={styles.buyBtnContainer}>
              <Clickable appNavTo={buyLink}>
                <span className={styles.logoContainer}>
                  <img
                    src={theme === "gz" ? logoGzImg : logoImg}
                    alt="logo"
                    className={styles.logo}
                  />
                </span>
                <div className={styles.buyBtnBtm}>
                  <CardButton disabled>在线购票</CardButton>
                </div>
                <span className={styles.logoContainer}>
                  <img src={logoImg} alt="logo" className={styles.logo} />
                </span>
              </Clickable>
            </li>
          </ul>
          <Clickable className={styles.buyButton} appNavTo={buyLink}>
            <img src={theme === "gz" ? buyGzImg : buyImg} alt="" />
          </Clickable>
          <Clickable
            className={classnames(styles.hamburger, {
              [styles.open]: open,
            })}
            onClick={() => {
              setOpen(open => !open)
            }}
          >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </Clickable>
        </div>
      </nav>
    </>
  )
})

export default Nav
